<template>
  <div class="plashka">
    <div class="plashka__header">
      <div class="plashka__name">
        <slot name="name">
          <span :title="name">{{ name }}</span>
        </slot>
      </div>
      <div class="plashka__status">
        <slot name="status"></slot>
      </div>
    </div>
    <div class="plashka__content">
      <slot>
        <div>1</div>
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, defineProps, defineEmits, onMounted, watch } from "vue";

// Определение пропсов компонента
const props = defineProps({
  isCompact: { type: Boolean, default: true }, // Исправлено "value" на "default"
  name: { type: String, default: "" },
});

// Определение эмиттеров событий компонента
const emits = defineEmits<{
  clickLogout: [];
  "update:message": [string];
}>();

// Отслеживание изменений пропса isCompact
watch(
  () => props.isCompact,
  () => {
    if (props.isCompact) {
      console.log("Свойство isCompact поменялось на true");
    }
  }
);
</script>

<style lang="scss">
.plashka {
  border-radius: 1rem;
  background-color: var(--bg-tertiary);
  flex: 1;
  min-width: 15rem;
  min-height: 11rem;
  padding: 1rem;
  display: flex; /* Добавляем flex для всего контейнера */
  flex-direction: column; /* Устанавливаем вертикальное направление */

  .plashka__header {
    display: flex;
    justify-content: space-between;
    font-size: 1rem;
    .plashka__name {
      font-weight: 500;
      white-space: nowrap;
      overflow: hidden;
      max-width: 50%;
      text-overflow: ellipsis;
    }
    .plashka__status {
      font-weight: 500;
    }
  }

  .plashka__content {
    flex: 1; /* Занимает оставшееся пространство */
    display: flex;
    justify-content: center; /* Горизонтальное выравнивание по центру */
    align-items: center; /* Вертикальное выравнивание по центру */
    font-size: 4.5rem;
    font-weight: 600;
  }
}
</style>
